import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IDocusignRedirectApiClient {
    getPathForDocusignRedirect(request: Models.DocusignRedirect.GetDocusignRedirectPathRequest.IGetDocusignRedirectPathRequest): ng.IPromise<string>;
}

export class DocusignRedirectApiClient implements IDocusignRedirectApiClient {
    public prefix: string;

    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
        this.prefix = "DocusignRedirect";
    }

    public getPathForDocusignRedirect = (request: Models.DocusignRedirect.GetDocusignRedirectPathRequest.IGetDocusignRedirectPathRequest): ng.IPromise<string> => {
        var url = `${this.prefix}/GetPathForDocusignRedirect`;
        return this.igsApiClientService.post(url, request);
    }
}
